export enum AttachmentType {
  /**
   * Image file.
   */
  Image = 'image',

  /**
   * Video file.
   */
  Video = 'video',

  /**
   * Audio file.
   */
  Audio = 'audio',

  /**
   * Location coordinates.
   */
  Location = 'location',

  /**
   * Document file.
   */
  Document = 'document',

  /**
   * A special command to invoke support functions on Sioslife's devices.
   */
  SystemCommand = 'system-command',
}
